export default "__VITE_ASSET__DxAd3op3__"